import { EVENT } from "../config";
import { Gift, Mail, CalendarPlus } from "lucide-react";

const toCal = (d) => new Date(d).toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

export const PracticalInfo = () => {
  const start = toCal(EVENT.date);
  const end = toCal(new Date(new Date(EVENT.date).getTime() + 20 * 60 * 60 * 1000));
  const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
    `${EVENT.name} turns ${EVENT.age} – ${EVENT.venue}`
  )}&dates=${start}/${end}&location=${encodeURIComponent(`${EVENT.venue}, ${EVENT.address}`)}`;

  return (
    <section
      className="px-6 py-16 md:px-16 md:py-24"
      data-testid="practical-section"
    >
      <div className="mx-auto max-w-4xl">
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#7A6A5E]">Good to know</p>
        <h2 className="font-display text-3xl font-light tracking-tight text-[#3F3A32] md:text-5xl">
          A few practical details
        </h2>

        <div className="mt-16 space-y-12">
          <div data-testid="practical-gifts">
            <div className="flex items-center gap-3">
              <Gift className="h-5 w-5 text-[#7A6A5E]" strokeWidth={1.5} />
              <p className="text-xs uppercase tracking-[0.2em] text-[#7A7264]">Presents</p>
            </div>
            <p className="mt-4 font-display text-xl font-light leading-relaxed tracking-tight text-[#3F3A32] md:text-2xl">
              {EVENT.giftsNote}
            </p>
          </div>

          <div className="h-px w-full bg-[#E4DCCA]" />

          <div data-testid="practical-questions">
            <div className="flex items-center gap-3">
              <Mail className="h-5 w-5 text-[#7A6A5E]" strokeWidth={1.5} />
              <p className="text-xs uppercase tracking-[0.2em] text-[#7A7264]">Questions</p>
            </div>
            <p className="mt-4 text-base font-light leading-relaxed text-[#5E574B]">
              Wondering about anything? You are warmly welcome to reach out at{" "}
              <a
                href={`mailto:${EVENT.contactEmail}`}
                data-testid="info-contact-link"
                className="text-[#7A6A5E] underline decoration-[#C9BFA9] underline-offset-4 transition-colors hover:text-[#3F3A32]"
              >
                {EVENT.contactEmail}
              </a>
            </p>
          </div>

          <div className="h-px w-full bg-[#E4DCCA]" />

          <div data-testid="practical-calendar">
            <div className="flex items-center gap-3">
              <CalendarPlus className="h-5 w-5 text-[#7A6A5E]" strokeWidth={1.5} />
              <p className="text-xs uppercase tracking-[0.2em] text-[#7A7264]">Save the date</p>
            </div>
            <a
              href={calendarUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="info-calendar-link"
              className="mt-4 inline-block text-base font-light text-[#7A6A5E] underline decoration-[#C9BFA9] underline-offset-4 transition-colors hover:text-[#3F3A32]"
            >
              Add the weekend to your calendar
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
